import clsx from 'clsx';
import React from 'react';

interface FieldLabelProps {
  children: React.ReactNode;
  className?: string;
  htmlFor: string;
}

const FieldLabel = ({ children, className, htmlFor }: FieldLabelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx(
        'mb-8 block font-suisse-intl-mono text-overline-sm text-grayscale-gray',
        className
      )}
    >
      {children}
    </label>
  );
};

export default FieldLabel;
